import { Col, Row, Container } from "react-bootstrap"
import "./Project.css";
import { ProjectCard } from "./ProjectCard";
import { ProjectModal } from "./ProjectModal";
import { useState } from "react";
import { ParticlesBg } from "./ParticlesBg";

export const Projects = (contentData) => {

    const [viewProject, setViewProject] = useState(false);
    const [projectSelected, setProjectSelected] = useState({});


    function handleView(project) {
        setProjectSelected(project)
        setViewProject(true);
    }


    return (
        <div className="projects-container" id="projects">
            <ParticlesBg className="particles-bg" />
            <ProjectModal showProject={viewProject} hideProject={() => setViewProject(false)} project={projectSelected} />
            <Container>
                <Row className="project-content align-items-center">
                    <Col className="d-flex flex-column align-items-center">
                        <h1 className="mb-5 mt-5 align-self-center esd-font s-header z-index-2 text-light">Projects</h1>

                        <div className="d-flex justify-content-center flex-wrap mb-5" >
                            {
                                contentData.contentData.projects.map((project, index) => (

                                    <ProjectCard project={project} key={index} viewProject={() => handleView(project)} />
                                ))
                            }
                        </div>

                        <a href="https://github.com/AnthonyMogotlane" target="_blank" className="view-all-btn mb-3 align-self-center" >View All Projects</a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}